import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AppShell from "./components/AppShell";
import LoginPage from "./pages/LoginPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import InviteAcceptPage from "./pages/InviteAcceptPage";
import DashboardPage from "./pages/DashboardPage";
import DoctorListPage from "./pages/doctors/DoctorListPage";
import DoctorFormPage from "./pages/doctors/DoctorFormPage";
import DoctorDetailPage from "./pages/doctors/DoctorDetailPage";
import VisitsRouter from "./pages/visits/VisitsRouter";
import LogVisitPage from "./pages/visits/LogVisitPage";
import VisitDetailPage from "./pages/visits/VisitDetailPage";
import LeavesRouter from "./pages/leaves/LeavesRouter";
import ApplyLeavePage from "./pages/leaves/ApplyLeavePage";
import LeaveDetailPage from "./pages/leaves/LeaveDetailPage";
import ExpensesRouter from "./pages/expenses/ExpensesRouter";
import ExpenseFormPage from "./pages/expenses/ExpenseFormPage";
import ExpenseDetailPage from "./pages/expenses/ExpenseDetailPage";
import TourPlansRouter from "./pages/tour-plans/TourPlansRouter";
import TourPlanDetailPage from "./pages/tour-plans/TourPlanDetailPage";
import AttendanceRouter from "./pages/attendance/AttendanceRouter";
import TeamPage from "./pages/team/TeamPage";
import AnalyticsPage from "./pages/analytics/AnalyticsPage";
import SettingsPage from "./pages/settings/SettingsPage";
import ProductMasterPage from "./pages/products/ProductMasterPage";
import TerritoryMasterPage from "./pages/territories/TerritoryMasterPage";
import FieldMapPage from "./pages/field-map/FieldMapPage";
import SamplesPage from "./pages/samples/SamplesPage";
import DistributorsPage from "./pages/distributors/DistributorsPage";
import ApprovalsPage from "./pages/approvals/ApprovalsPage";
import { UserGuidePage } from "./pages/ModulePages";
import { Toaster } from "./components/ui/sonner";
import UpdatePrompt from "./components/UpdatePrompt";
import "./App.css";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/invite/accept" element={<InviteAcceptPage />} />

          {/* Protected app shell */}
          <Route element={<ProtectedRoute />}>
            <Route element={<AppShell />}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/attendance" element={<AttendanceRouter />} />
              <Route path="/doctors" element={<DoctorListPage />} />
              <Route path="/doctors/new" element={<DoctorFormPage />} />
              <Route path="/doctors/:id" element={<DoctorDetailPage />} />
              <Route path="/doctors/:id/edit" element={<DoctorFormPage />} />
              <Route path="/doctor-visits" element={<VisitsRouter />} />
              <Route path="/doctor-visits/new" element={<LogVisitPage />} />
              <Route path="/doctor-visits/:id" element={<VisitDetailPage />} />
              <Route path="/doctor-visits/:id/edit" element={<LogVisitPage />} />
              <Route path="/approvals" element={<ApprovalsPage />} />
              <Route path="/leaves" element={<LeavesRouter />} />
              <Route path="/leaves/apply" element={<ApplyLeavePage />} />
              <Route path="/leaves/:id" element={<LeaveDetailPage />} />
              <Route path="/route-planner" element={<TourPlansRouter />} />
              <Route path="/route-planner/:id" element={<TourPlanDetailPage />} />
              <Route path="/expenses" element={<ExpensesRouter />} />
              <Route path="/expenses/new" element={<ExpenseFormPage />} />
              <Route path="/expenses/:id" element={<ExpenseDetailPage />} />
              <Route path="/expenses/:id/edit" element={<ExpenseFormPage />} />
              <Route path="/analytics" element={<AnalyticsPage />} />
              <Route path="/samples" element={<SamplesPage />} />
              <Route path="/distributors" element={<DistributorsPage />} />
              <Route path="/user-guide" element={<UserGuidePage />} />
            </Route>
          </Route>

          {/* Manager+ */}
          <Route element={<ProtectedRoute allowRoles={["assistant_manager", "admin_manager", "admin", "director"]} />}>
            <Route element={<AppShell />}>
              <Route path="/field-map" element={<FieldMapPage />} />
              {/* Since #15 both manager tiers manage teams here (induct /
                  reassign / release). Account administration inside the page
                  stays admin/director-gated. */}
              <Route path="/team" element={<TeamPage />} />
            </Route>
          </Route>

          {/* Product Master — Admin Manager + Admin + Director manage */}
          <Route element={<ProtectedRoute allowRoles={["admin_manager", "admin", "director"]} />}>
            <Route element={<AppShell />}>
              <Route path="/products" element={<ProductMasterPage />} />
              <Route path="/territories" element={<TerritoryMasterPage />} />
            </Route>
          </Route>

          {/* Admin/Director only */}
          <Route element={<ProtectedRoute allowRoles={["admin", "director"]} />}>
            <Route element={<AppShell />}>
              <Route path="/settings" element={<SettingsPage />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        <Toaster richColors position="top-right" />
        <UpdatePrompt />
      </BrowserRouter>
    </AuthProvider>
  );
}
